"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedCategoryTrees = void 0;
var getUniqueCategoriesFromFieldList = function (fields) {
    return Array.from(new Set(fields.map(function (f) { return f.categoryName; })));
};
var getUniqueSubCategoryMap = function (fields) {
    var categories = getUniqueCategoriesFromFieldList(fields);
    var subCategoryMap = new Map();
    categories.forEach(function (category) {
        var subCategories = fields
            .filter(function (field) { return field.categoryName === category && field.subcategoryName; })
            .map(function (field) { return field.subcategoryName; });
        var uniqueSubCategories = Array.from(new Set(subCategories));
        subCategoryMap.set(category, uniqueSubCategories);
    });
    return subCategoryMap;
};
var getNestedCategoryTrees = function (fields) {
    var categories = getUniqueCategoriesFromFieldList(fields);
    var subCategoryMap = getUniqueSubCategoryMap(fields);
    return categories.map(function (category) {
        return {
            categoryName: category,
            subCategories: subCategoryMap.get(category).map(function (subCategoryName) { return ({
                subCategoryName: subCategoryName,
                fields: fields.filter(function (field) {
                    return field.categoryName === category &&
                        field.subcategoryName === subCategoryName;
                })
            }); }),
            fields: fields.filter(function (field) {
                return field.categoryName === category && field.subcategoryName === null;
            })
        };
    });
};
exports.getNestedCategoryTrees = getNestedCategoryTrees;
